import Dashboard from 'pages/dashboard/Dashboard';

interface RoleBasedDashboardProps {
  children?: React.ReactNode;
}

// Every role gets the same dashboard: it shows the work lists the user's
// sidebar shows, counted the way each list page counts them. The former
// per-role dashboards (legal translation, awareness and legal research
// prosecutor/coordinator) are no longer opened from here; their routes in
// App.tsx still work if linked directly.
const RoleBasedDashboard: React.FC<RoleBasedDashboardProps> = () => <Dashboard />;

export default RoleBasedDashboard;
